import { Typography } from '@mui/material';
import { useState } from 'react';
import { useForm } from 'react-hook-form';

import Logger from 'browser-logging/src/browser/Logger';

import { sendContactRequest as sendContactRequestService } from 'portal/src/api/ContactUsService';
import { FormContainer } from 'portal/src/components/common/forms/FormContainer';
import { MESSAGES } from 'portal/src/constants/snackbarMessages';

import useSnackbarHandler from '../../utils/Snackbar/useSnackbarHandler';
import { defaultValues, getFields } from './Form/ContactUs.fields';

const ContactUs = () => {
  const snackbarHandler = useSnackbarHandler();

  const [pendingRequest, setPendingRequest] = useState(false);

  const {
    control,
    handleSubmit,
    reset,
    formState: { isDirty },
  } = useForm({
    defaultValues: defaultValues(),
  });

  const sendContactRequest = async (data: any) => {
    setPendingRequest(true);
    try {
      await sendContactRequestService(data);
      snackbarHandler.success(MESSAGES.GENERIC.CONTACT_REQUEST_SENT);
      reset(defaultValues());
    } catch (err) {
      Logger.captureError(err as Error);
      snackbarHandler.error(MESSAGES.GENERIC.ERROR);
    } finally {
      setPendingRequest(false);
    }
  };

  const resetForm = async () => {
    reset(defaultValues());
  };

  return (
    <FormContainer
      buttonLayout="bottom"
      columnNumber={1}
      control={control}
      isDirty={isDirty}
      handleSubmit={handleSubmit(sendContactRequest)}
      hideCancelButton
      isNew
      isPending={pendingRequest}
      maxWidth={900}
      resetForm={resetForm}
      saveOrUpdateLabel="Send Message"
      beforeMainFields={
        <>
          <Typography
            variant="h4"
            sx={{ fontWeight: 'bold', textAlign: 'center' }}
          >
            Contact Us
          </Typography>
          <Typography variant="body1" sx={{ mb: 2, textAlign: 'center' }}>
            We&apos;d love to hear from you. Send us a message and we&apos;ll
            respond as soon as possible.
          </Typography>
        </>
      }
      mainFieldsConfig={getFields()}
    />
  );
};

export default ContactUs;
